import { useTranslation } from "react-i18next"

function BlankModal({
    modalId = "modal_id",
    buttonClass = "btn-primary",
    buttonLabel = <>Click</>,
    title,
    body,
    footer = <></>,
    locked = false,
}) {

    const [t] = useTranslation("global")
    let closeButtonId = `closeModalButton_${modalId}`


    return (
        <>
            <button type="button" className={`btn ${buttonClass}`} data-bs-toggle="modal" data-bs-target={`#${modalId}`}>
                {buttonLabel}
            </button>
            <div className="modal fade text-start" id={`${modalId}`} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content bg-dark">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">{title? title : t("helper.confirm_request")}</h1>
                            <button type="button" className="btn-close bg-light" id={closeButtonId} data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body bg-black bg-opacity-25">
                            {body}
                        </div>
                        <div className="modal-footer">
                            {footer}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BlankModal